import { Avatar, Box, Card, Chip, Stack, Typography } from '@mui/material';

import { type CircleMember } from '@/karehero-app/onboarding/Onboarding.content';

/**
 * One person in a care circle: who they are and how they are related.
 *
 * Out of CareCircle so the intake's invite sheet can list who it has already
 * invited with the same card the circle itself uses.
 */
const CircleMemberCard = ({
  member,
}: {
  member: Pick<CircleMember, 'initials' | 'name' | 'role'>;
}) => (
  <Card sx={{ p: 0, overflow: 'hidden' }}>
    <Stack sx={{ alignItems: 'center', p: 2 }} direction='row' spacing={1.5}>
      <Avatar
        sx={{
          width: 40,
          height: 40,
          bgcolor: 'custom.limeGreen.500',
          color: 'primary.main',
          fontSize: 13,
        }}
      >
        {member.initials}
      </Avatar>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant='h6'>{member.name}</Typography>
        {member.role && (
          <Typography sx={{ color: 'text.secondary' }} variant='body2'>
            {member.role}
          </Typography>
        )}
      </Box>
      <Chip label='Invited' size='small' variant='outlined' />
    </Stack>
  </Card>
);

export default CircleMemberCard;
